/** 变量前缀 */
const PRE = '--el-color-primary'
const PRE_LIGHT = `${PRE}-light`
const PRE_DARK = `${PRE}-dark`

/** 白色 */
const WHITE = '#ffffff'
/** 黑色 */
const BLACK = '#000000'

export { PRE, PRE_LIGHT, PRE_DARK, WHITE, BLACK }
